// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_29-6";
export var headerCell = "_29-2";
export var rowWrapper = "_29-4";
export var stickyAggregationCell = "_29-a";
export var stickyAggregationRow = "_29-7";
export var stickyColumnCell = "_29-9";
export var stickyColumnHeaderCell = "_29-8";
export var table = "_29-1";
export var virtualRowWrapper = "_29-5";
export var virtualTableContainer = "_29-0";
export var white = "_29-3";